import {useCallback, useState} from 'react';
import {useQueryClient} from '@tanstack/react-query';
import {openBase64} from 'presentation/utils';
import {RecoverFileParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {postRecoverFile} from '../services/postRecoverFile';

export const useRecoverFileHandler = () => {
	const [nuFileState, setNuFileState] = useState<number>();
	const [isFetchingRecoverFile, setIsFetchingRecoverFile] = useState(false);
	const queryClient = useQueryClient();

	const getRecoverFileUrl = useCallback(
		async (fileParams: RecoverFileParams) => {
			setNuFileState(fileParams.nuArquivo);
			setIsFetchingRecoverFile(true);

			try {
				const data = await queryClient.fetchQuery({
					queryKey: [QUERY_KEYS.AUTOSOL_RECOVER_FILE, fileParams],
					queryFn: async ({signal}) => postRecoverFile({...fileParams, signal}),
				});

				if (!data?.arquivoBase64) {
					throw new Error('Arquivo não encontrado.');
				}

				openBase64(
					`data:application/${data.extensaoArquivo};base64,${data.arquivoBase64}`,
					data.nmArquivo,
				);
			} catch (error) {
				// eslint-disable-next-line no-console
				console.error('Erro ao recuperar o arquivo:', error);
				throw new Error('Falha ao abrir o arquivo.');
			} finally {
				setIsFetchingRecoverFile(false);
			}
		},
		[queryClient],
	);

	return {
		isFetchingRecoverFile,
		nuFileState,
		getRecoverFileUrl,
	};
};
